<template>
  <div
    class="right"
    v-if="project.projectMembers && project.projectMembers.length"
  >
    <user
      class="user"
      :users="project.owners"
      text="Project Owner"
      v-if="project.owners && project.owners.length"
    />

    <user
      class="user"
      :users="project.sponsors"
      text="Sponsor"
      v-if="project.sponsors && project.sponsors.length"
    />

    <user
      class="user"
      :users="project.members"
      text="Key Stakeholder"
      v-if="project.members && project.members.length"
    />

    <user
      class="user"
      :users="project.others"
      text="Other Stakeholder"
      v-if="project.others && project.others.length"
    />
  </div>
</template>

<script>
import User from './User';

export default {
  name: 'ProjectMembers',
  props: {
    project: Object,
  },
  components: {
    user: User,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.right {
  min-width: 262px;
  max-width: 34%;
  min-height: 300px;
  flex: 1;
  background: #fbfbfc;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 32px 42px;
  margin: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  .user {
    margin: 0 0 20px;

    &:last-child {
      margin-bottom: 0;
    }

    ::v-deep .user {
      margin: 0;
    }
  }
}
</style>
